export enum ApprovalTaskStatusOptions {
	APPROVED = 'APPROVED',
	REJECTED = 'REJECTED',
	APPROVAL_PENDING = 'APPROVAL_PENDING',
}

export const getStylesForLabel = (
  status: ApprovalTaskStatusOptions
) => {
  switch (status) {
    case ApprovalTaskStatusOptions.APPROVED:
      return {
        text: 'Approved',
        styles: {
          borderColor: '#0F8E4E',
          color: '#0F8E4E',
          background: '#DEFFEE',
        },
      };
    // case 'Approval Needed':
    //   return {
    //     borderColor: '#4A4650',
    //     color: '#4A4650',
    //     background: '#F2EFF5',    
    //   };
    case ApprovalTaskStatusOptions.REJECTED:
      return {
        text: 'Rejected',
        styles: {
          borderColor: '#F24E4E',
          color: '#F62C2C',
          background: '#FFEFEF',    
        },
      };
    case ApprovalTaskStatusOptions.APPROVAL_PENDING:
      return {
        text: 'Approval Pending',
        styles: {
          borderColor: '#8B1FCA',
          color: '#8B1FCA',
          background: '#F0D6FF',    
        },
      };
    default:
      return {};
  }
};
